export const HFG_POSSIBLE_BONUS_ADD_ONS = ['kenoBonus', 'kenoBooster', 'kenoMultiplier']
export const HFG_DRAW_RESULT_MAIN_FIELD = 'main'
